<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-text-input [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                         (focussed$)="onFocussed($event)" *ngSwitchDefault [notation]="notation"
                         [placeholder]="placeholder"></fui-edit-text-input>
    <fui-filter-text-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value" [placeholder]="placeholder"
                           (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.FILTER"></fui-filter-text-input>
    <fui-inline-text-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                           (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE" [notation]="notation"
                           [placeholder]="placeholder"></fui-inline-text-input>
    <fui-text-pill [control]="control" [disabled]="disabled" [label]="label" #input [(ngModel)]="value"
                   (focussed$)="onFocussed($event)"
                   [removable]="removable" (removed$)="remove()" [placeholder]="placeholder"
                   *ngSwitchCase="contextType.PILL"></fui-text-pill>
</ng-container>
